import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher, FaGlobeAfrica, FaHospital, FaUserClock } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import { MdCheckCircle, MdHome, MdLightMode, MdLocationPin, MdSearch, MdSupport, MdVerified } from "react-icons/md";
import pr1 from '../assets/pr1.jpg';
import pr2 from '../assets/pr2.jpg';
import pr3 from '../assets/pr3.jpg';
import pr4 from '../assets/pr4.jpg';
import pr5 from '../assets/pr5.jpg';
import pr6 from '../assets/pr6.jpg';
import pr7 from '../assets/pr7.jpg';
import pr8 from '../assets/pr8.jpg';
import pr9 from '../assets/pr9.jpg';
import pr10 from '../assets/pr10.jpg';
import pr11 from '../assets/pr11.jpg';
import pr12 from '../assets/pr12.jpg';
import logo from '../assets/logo.png';
import OneObjective from "./OneObjective";

export default function AboutUsContent(props) {

	const appContext = useContext(AppContext);

	const [ ready, setReady ] = useState(false);

	async function init() {
		setReady(false);
		//.. any other initialization
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<div 
				className="MainBodySection"
				style={{
					paddingBottom: "50px",
					paddingTop: "50px"
				}}
			>
				<div className="container">
					<div className="row">
						{/* Existing About Us Header */}
						<div className="col-md-12">
							<h6 className="main-section-title">
								About Us
								<span style={{ display: "block", borderBottom: "3px solid var(--secondaryColor)", width: "50px", marginTop: "10px" }}></span>
							</h6>
						</div>

						{/* Logo */}
						<div className="col-md-6 text-center mb-3 mt-3">
							<div className="card">
								<div className="card-body">
									<img src={logo} style={{ width: "100%" }} />
								</div>
							</div>
						</div>

						{/* Company Intro */}
						<div className="col-md-6 mt-3 mb-3">
							<p style={{ fontSize: "16px" }}>
								CareMed Gas Ltd is a premier Tanzanian company that specializes in providing medical and industrial gas solutions across East Africa. We supply, design, install, maintain, and certify Medical Gas Pipeline Systems (MGPS), PSA oxygen plants, manifolds, vacuum plants, and specialized engineering solutions for healthcare facilities. Our operations comply with HTM 02-01, NFPA 99, ISO 7396-1, WHO standards, and other global regulations. With years of experience, we have supported government hospitals, private institutions, industries, and international health projects with reliable, safe, and affordable gas solutions.
							</p>
						</div>

						{/* Stats */}
						<div className="col-md-12 mt-3 mb-3">
							<div className="row text-center">
								<div className="col-md-4 mb-4">
									<div className="p-4 rounded-4 bg-white bg-opacity-10 shadow-sm h-100">
										<FaUserClock className="display-4 mb-3 text-warning" />
										<h2 className="fw-bold fs-1">7+</h2>
										<p className="fs-5 mb-0">Years Experience</p>
									</div>
								</div>
		
								<div className="col-md-4 mb-4">
									<div className="p-4 rounded-4 bg-white bg-opacity-10 shadow-sm h-100">
										<FaGlobeAfrica className="display-4 mb-3 text-success" />
										<h2 className="fw-bold fs-1">4+</h2>
										<p className="fs-5 mb-0">Countries Served</p>
									</div>
								</div>
		
								<div className="col-md-4 mb-4">
									<div className="p-4 rounded-4 bg-white bg-opacity-10 shadow-sm h-100">
										<FaHospital className="display-4 mb-3 text-info" />
										<h2 className="fw-bold fs-1">20+</h2>
										<p className="fs-5 mb-0">Hospitals Supported</p>
									</div>
								</div>
							</div>
						</div>

						{/* Brand & Legal Info */}
						<div className="col-md-12 mt-3 mb-3">
							<div style={{ padding: "30px" }} className="bg-surface mt-4 mb-4 text-start mShadow2">
								<p style={{ fontSize: "18px" }}>
									Caremed Gas Ltd concentrates on brand building and brand custodianship in terms of representing its national and international brands in the Tanzania wholesale and retail sector.
									<br/><br/>
									We strive to build awareness of the brand through distribution and listings in the retail trade, in-store promotions, sampling, gondola ends, and price deals.
									<br/><br/>
									We also conduct targeted advertising and advertorials for premier brands in our portfolio.
									<br/><br/>
									Caremed Gas Ltd has regional offices and dedicated sales personnel to reach even the most interior regions of Tanzania.
								</p>

								<h6 className="font-bold">LEGAL INFORMATION</h6>
								<div className="font-bold">
									<h6 className="font-bold text-primary" style={{ fontSize: 14 }}>Business Name: CAREMED GAS LIMITED</h6>
									<h6 className="font-bold text-primary" style={{ fontSize: 14 }}>Mailing Address: Plot No. 64/3 Kijitonyama Road, Dar es salaam.</h6>
									<h6 className="font-bold text-primary" style={{ fontSize: 14 }}>Phone: +255705998527</h6>
									<h6 className="font-bold text-primary" style={{ fontSize: 14 }}>Email: info@caremedgaslimited.com</h6>
									<h6 className="font-bold text-primary" style={{ fontSize: 14 }}>Business Type: Medical Devices</h6>
									<h6 className="font-bold text-primary" style={{ fontSize: 14 }}>Certificate of Incorporation: 166197740</h6>
									<h6 className="font-bold text-primary" style={{ fontSize: 14 }}>TIN No: 166-197-740</h6>
									<h6 className="font-bold text-primary" style={{ fontSize: 14 }}>Primary Line of Business: Importation, Distribution & Maintenance of Medical Equipment’s</h6>
									<h6 className="font-bold text-primary" style={{ fontSize: 14 }}>Secondary Audience: Local Organizations and International Organizations</h6>
								</div>
							</div>
						</div>

						{/* Medical Gases Section */}
						{/* Medical Gases */}
						<div className="col-md-12 mt-5 mb-5">
							<h2 className="mb-4 text-primary fw-bold text-center">
								Medical Gases
							</h2>

							<div className="row g-4 justify-content-center">
								{[
								{
									formula: "O₂",
									title: "Medical Oxygen",
									description: "Essential for patient life support. Used in ICUs, theatres, emergencies, wards, NICU and ambulances. Produced via cryogenic process or PSA oxygen plants."
								},
								{
									formula: "Air",
									title: "Medical Air",
									description: "Clean, compressed, dry, medical-grade air used for ventilation, nebulization, anesthesia machines, surgical tools and neonatal care."
								},
								{
									formula: "N₂O",
									title: "Nitrous Oxide",
									description: "Commonly known as laughing gas. Used in anesthesia for pain management, obstetrics, and dental procedures."
								},
								{
									formula: "CO₂",
									title: "Carbon Dioxide",
									description: "Used for laparoscopic surgeries, cryotherapy, lab applications, and calibration gases."
								},
								{
									formula: "Vacuum",
									title: "Vacuum Systems",
									description: "For airway clearance, drainage, emergency suctioning, and surgical operations. Must maintain negative pressure per HTM standards."
								},
								{
									formula: "AGSS",
									title: "Anaesthetic Gas Scavenging System",
									description: "Removes waste anesthetic gases from theatres to protect medical staff and maintain a safe environment."
								}
								].map((gas, index) => (
								<div key={index} className="col-md-6 col-lg-4">
									<div className="card h-100 text-center shadow-sm border-0 rounded-3 p-4 hover-scale">
									<div className="display-4 fw-bold text-primary mb-3">{gas.formula}</div>
									<h5 className="fw-bold mb-2">{gas.title}</h5>
									<p className="card-text" style={{ fontSize: "16px", lineHeight: "1.6" }}>
										{gas.description}
									</p>
									</div>
								</div>
								))}
							</div>
						</div>

						{/* Industrial Gases Section */}
						<div className="col-12 mt-5 mb-5">
						<h2 className="text-center text-primary fw-bold mb-4">Industrial Gases</h2>

						<div className="row g-4 justify-content-center text-center">
							{[
							{
								formula: "O₂",
								title: "Industrial Oxygen",
								description: "Used for welding, cutting, combustion, metal fabrication, and manufacturing processes."
							},
							{
								formula: "C₂H₂",
								title: "Acetylene",
								description: "Primary fuel gas for welding and cutting due to high flame temperature and efficiency."
							},
							{
								formula: "Ar",
								title: "Argon",
								description: "Inert gas used for TIG and MIG welding, shielding metals from oxidation."
							},
							{
								formula: "N₂",
								title: "Nitrogen",
								description: "Used in food processing, packaging, cooling, labs, HVAC testing, and industrial blanketing."
							},
							{
								formula: "He",
								title: "Helium",
								description: "Used in leak detection, lab analysis, MRI machines, and high-tech manufacturing."
							},
							{
								formula: "Mixed",
								title: "Mixed Welding Gases",
								description: "Customized blends for optimized welding performance, stability, and metal quality."
							}
							].map((gas, index) => (
							<div key={index} className="col-12 col-md-6 col-lg-4 d-flex flex-column align-items-center">
								<div className="border rounded p-3 flex-grow-1" style={{ width: "100%", maxWidth: "300px" }}>
								<div className="display-4 fw-bold text-primary mb-2">{gas.formula}</div>
								<h5 className="fw-bold mb-2">{gas.title}</h5>
								<p className="mb-0" style={{ fontSize: "16px", lineHeight: "1.6" }}>{gas.description}</p>
								</div>
							</div>
							))}
						</div>
						</div>


						{/* Our Services */}
						<div className="col-md-12 mt-5 mb-5">
						<h2 className="mb-4 text-primary text-center fw-bold">
							Our Services
						</h2>
						<div className="row g-4">
							{[
							"Design, Installation & Commissioning of Medical Gas Pipeline Systems (MGPS).",
							"PSA Oxygen Plant installation (50–3000 LPM).",
							"Supply of cylinders, regulators, valves, flowmeters, and pipeline accessories.",
							"Vacuum plants and medical air compressor systems.",
							"Manifold systems (O₂, N₂O, CO₂, MA).",
							"MGPS testing, VP certification, HTM compliance, and leakage testing.",
							"Annual maintenance contracts and emergency backup support.",
							"Industrial gas supply and bulk cylinder distribution.",
							"Technical training for biomedical engineers and plant operators."
							].map((service, index) => (
							<div key={index} className="col-md-6 col-lg-4">
								<div className="card h-100 shadow-sm border-0 rounded-3 p-3 hover-scale">
								<div className="card-body">
									<p className="card-text" style={{ fontSize: "16px", lineHeight: "1.6" }}>
									{service}
									</p>
								</div>
								</div>
							</div>
							))}
						</div>

						</div>

						{/* Our Experience */}
						<div className="col-12 mt-5 mb-5">
						<h2 className="text-center text-primary fw-bold mb-4">Our Experience</h2>

						<p className="text-center mx-auto mb-4" style={{ maxWidth: "700px", fontSize: "16px" }}>
							We have completed MGPS works, oxygen plants, manifold installations, pipeline upgrades, and annual maintenance contracts in various institutions:
						</p>

						<div className="row g-3 justify-content-center">
							{[
							"Regional Referral Hospitals",
							"District Hospitals",
							"Private Hospitals and Specialist Clinics",
							"International NGO medical projects",
							"Industrial clients in manufacturing, welding, and processing sectors"
							].map((item, index) => (
							<div key={index} className="col-12 col-md-6 d-flex align-items-center">
								<div className="d-flex align-items-center justify-content-center rounded-circle bg-primary text-white flex-shrink-0 me-3" style={{ width: "35px", height: "35px", fontWeight: "bold" }}>
								&#10003;
								</div>
								<div className="border rounded p-3 flex-grow-1 bg-light">
								<p className="mb-0" style={{ fontSize: "16px", lineHeight: "1.6" }}>{item}</p>
								</div>
							</div>
							))}
						</div>

						<p className="text-center mx-auto mt-4" style={{ maxWidth: "700px", fontSize: "16px" }}>
							Our team has handled projects across Tanzania and in cross-border regions, making CAREMED one of the most experienced providers in East Africa.
						</p>
						</div>

						{/* Why Choose Us */}
						<div className="col-12 mt-5 mb-5">
						<h2 className="text-center text-primary fw-bold mb-4">Why Choose Us</h2>

						<div className="row g-3 justify-content-center">
							{[
							"Compliance with international medical standards (HTM, NFPA, ISO).",
							"Highly experienced biomedical and mechanical engineers.",
							"24/7 emergency support and rapid response teams.",
							"High-grade, certified, and reliable gas products.",
							"Proven track record in hospital engineering and industrial systems.",
							"Competitive pricing and reliable supply chain."
							].map((item, index) => (
							<div key={index} className="col-12 col-md-6 d-flex align-items-center">
								<div className="d-flex align-items-center justify-content-center rounded-circle bg-primary text-white flex-shrink-0 me-3" style={{ width: "35px", height: "35px", fontWeight: "bold" }}>
								&#10003;
								</div>
								<div className="border rounded p-3 flex-grow-1 bg-light">
								<p className="mb-0" style={{ fontSize: "16px", lineHeight: "1.6" }}>{item}</p>
								</div>
							</div>
							))}
						</div>
						</div>


						{/* Existing Vision, Mission, Values sections remain untouched */}
						<div className="col-md-6 bg-secondary">
							<h6 style={{ fontSize: "32px", textTransform: "uppercase" }} className="text-center font-bold mt-5 mb-2">
								OUR VISION
							</h6>
							<h6 style={{ fontSize: "16px", padding: "20px" }} className="font-semi-bold">
								To be Africa’s most trusted and innovative provider of medical and industrial gases, engineering solutions, and life-support systems.
							</h6>
						</div>

						<div className="col-md-6 bg-surface">
							<h6 style={{ fontSize: "32px", textTransform: "uppercase" }} className="text-center font-bold mt-5 mb-2">
								OUR MISSION
							</h6>
							<h6 style={{ fontSize: "16px", padding: "20px" }} className="font-semi-bold">
								• To strengthen healthcare delivery through reliable medical gas solutions.
								<br/>• To provide safe and high-quality industrial gas supply for production and manufacturing.
								<br/>• To deliver world-class MGPS engineering, installation, and certification services.
								<br/>• To support facilities with continuous maintenance, training, and technical upgrades.
							</h6>
						</div>

						<div className="col-md-12">
							<h6 style={{ fontSize: "32px", }} className="text-center font-bold text-primary mt-5 mb-2">
								Our Values
							</h6>
							<div className="row">
								<div className="col-md-4"><OneObjective icon={<MdCheckCircle size={42} className="text-muted"/>} content="Integrity"/></div>
								<div className="col-md-4"><OneObjective icon={<MdCheckCircle size={42} className="text-muted"/>} content="Efficiency"/></div>
								<div className="col-md-4"><OneObjective icon={<MdCheckCircle size={42} className="text-muted"/>} content="Quality"/></div>
								<div className="col-md-3"><OneObjective icon={<MdCheckCircle size={42} className="text-muted"/>} content="Safety"/></div>
								<div className="col-md-3"><OneObjective icon={<MdCheckCircle size={42} className="text-muted"/>} content="Innovation"/></div>
								<div className="col-md-3"><OneObjective icon={<MdVerified size={42} className="text-muted"/>} content="Reliability"/></div>
								<div className="col-md-3"><OneObjective icon={<MdSupport size={42} className="text-muted"/>} content="Customer centered"/></div>
							</div>
						</div>

					</div>
				</div>
			</div>
		)
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
